<template>
  <!-- Linha flat da cotação: hairline entre linhas, preço em destaque na cor
       da marca, hierarquia por tipografia (sem caixas) -->
  <div v-if="header" class="calc-row calc-row--head">
    <span class="calc-row__carrier">Transportadora</span>
    <span class="calc-row__modality">Modalidade</span>
    <span class="calc-row__deadline">Prazo</span>
    <span class="calc-row__price">Valor</span>
    <span class="calc-row__action"></span>
  </div>
  <div v-else class="calc-row">
    <span class="calc-row__carrier"><img :src="logo" alt="" /></span>
    <span class="calc-row__modality">{{ modality }}</span>
    <template v-if="data.available">
      <span class="calc-row__deadline">
        <i class="el-icon-time"></i>
        <span v-if="sameDayDeadlineLabel">{{ sameDayDeadlineLabel }}</span>
        <span v-else-if="displayDeadlineDays !== null">{{ displayDeadlineDays }} à {{ displayDeadlineDays + 1 }} dias</span>
      </span>
      <span class="calc-row__price">
        {{ format(price) }}
        <el-tooltip v-if="tooltip" effect="dark" placement="top-start">
          <div slot="content">
            Frete: {{ format(price) }}
            <br />
            <span v-if="data.warning > 0"> A.R.: {{ format(data.warning) }}<br /></span>
            <span v-if="data.digital > 0"> A.R-E: {{ format(data.digital) }}<br /></span>
            <span v-if="data.ownhand > 0"> M.P.: {{ format(data.ownhand) }}<br /></span>
            <span v-if="data.declared > 0"> Seguro: {{ format(data.declared) }}<br /></span>
          </div>
          <i class="el-icon-info calc-row__price-info"></i>
        </el-tooltip>
      </span>
    </template>
    <span v-else class="calc-row__unavailable">
      <el-tag type="danger" size="small">{{ data.description }}</el-tag>
    </span>
    <span class="calc-row__action">
      <el-button v-if="data.available" type="primary" size="small" @click="redirect">{{ label }}</el-button>
    </span>
  </div>
</template>

<script>
import { getDisplayedDeadlineDays, isSameDayDeadline, TODAY_DEADLINE_LABEL } from "@/utils/shipping-deadline";

export default {
  name: "CalculateResultItem",
  props: ["header", "logo", "deadline", "price", "modality", "cash", "savings", "data", "label", "line"],
  computed: {
    displayDeadlineDays() {
      return getDisplayedDeadlineDays(this.data, this.deadline);
    },
    sameDayDeadlineLabel() {
      return isSameDayDeadline(this.data, this.deadline) ? TODAY_DEADLINE_LABEL : null;
    },
    tooltip() {
      return this.data.warning > 0 || this.data.digital > 0 || this.data.ownhand > 0 || this.data.declared > 0;
    },
  },
  methods: {
    format(value) {
      return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", minimumFractionDigits: 2 }).format(
        value
      );
    },
    redirect() {
      localStorage.setItem("POST_QUOTATION", JSON.stringify(this.data));
      this.$emit("redirect", this.line);
    },
  },
};
</script>

<style>
.calc-row {
  display: flex;
  align-items: center;
  padding: 10px 4px;
  border-bottom: 1px solid #f0f2f5;
  font-size: 13px;
  color: #606266;
  transition: background-color 0.15s ease;
}

.calc-row:not(.calc-row--head):hover {
  background-color: #f5f7fa;
}

.calc-row:last-child {
  border-bottom: none;
}

.calc-row--head {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #909399;
  padding: 4px 4px 8px;
}

.calc-row--head span {
  white-space: nowrap;
}

.calc-row__carrier {
  flex: 0 0 130px;
}

.calc-row__carrier img {
  max-width: 100px;
  vertical-align: middle;
}

.calc-row__modality {
  flex: 1 1 auto;
  font-weight: 600;
  color: #303133;
}

.calc-row--head .calc-row__modality {
  font-weight: 600;
  color: #909399;
}

.calc-row__deadline {
  flex: 0 0 130px;
  white-space: nowrap;
}

.calc-row__deadline i {
  color: #c0c4cc;
  margin-right: 4px;
}

.calc-row__price {
  flex: 0 0 150px;
  font-size: 16px;
  font-weight: 700;
  color: #22418d;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.calc-row--head .calc-row__price {
  font-size: 11px;
  font-weight: 600;
  color: #909399;
}

.calc-row__price-info {
  font-size: 13px;
  color: #c0c4cc;
  cursor: help;
  margin-left: 3px;
}

.calc-row__unavailable {
  flex: 1 1 auto;
  text-align: left;
}

.calc-row__action {
  flex: 0 0 100px;
  text-align: right;
}

@media only screen and (max-width: 600px) {
  .calc-row__carrier {
    flex-basis: 70px;
  }

  .calc-row__carrier img {
    max-width: 60px;
  }

  .calc-row__deadline {
    flex-basis: 100px;
  }

  .calc-row__price {
    flex-basis: 110px;
    font-size: 14px;
  }
}
</style>
